import React from "react";
import axios from "axios";
import { withRouter } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../assets/styles/datepicker-custom.css";
import { ReactComponent as CalendarIcon } from "../../assets/images/icons/calendar_16.svg";

import {
  getAuthorizationHeader,
  URL,
  username,
  idEmpresa
} from "../../constans/constants";
import { obtenerDatosUsuario } from "../usuario/UsuarioService";
import { getSaldoByUsername, getLegajoIdByUsername } from "../vacaciones/VacacionesService";
import PantallaCarga from "../mensajeFlash/PantallaCarga";
import {
  mostrarErroresEnFormulario, configurarLimpiezaAutomatica,
  integrarConHandleInput, limpiarErrorCampo
} from '../../constans/form-error-utils';

const CustomDateInput = React.forwardRef(({ value, onClick, onChange, name, label }, ref) => (
  <div className="datepicker-wrapper">
    <div className="form-group-local">
      <input
        type="text"
        className="form-input"
        onClick={onClick}
        onChange={onChange}
        value={value}
        name={name}
        ref={ref}
        id={name}
        autoComplete="off"
        placeholder=""
      />
      <label htmlFor={name} className="form-label">
        {label}
      </label>
      <span className="icon-calendar-local">
        <CalendarIcon width={16} height={16} />
      </span>
    </div>

  </div>
));

class SolicitudVacaciones extends React.Component {
  constructor(props) {
    super(props);

    const originalHandleInput = this.handleInput;

    this.handleInput = integrarConHandleInput(this, originalHandleInput);

    this.state = {
      nombre: "",
      periodo: "",
      fechaDesde: "",
      fechaHasta: "",
      totalCorrespondientes: "",
      totalPendientes: "",
      totalSolicitados: "",
      legajoId: null,
      fechaDesdeCargada: false,
      fechahastaCargada: false,
      validated: false,
      openPantallaCarga: false,
      errors: {
        periodo: null,
        fechaDesde: null,
        fechaHasta: null,
        totalCorrespondientes: null,
        totalPendientes: null,
        totalSolicitados: null
      },
      showErrors: false
    };
  }

  componentDidMount() {
    configurarLimpiezaAutomatica();
    const u = username();
    this.fetchDatosUsuario(u);
    this.fetchSaldo(u);
    getLegajoIdByUsername(u).then(res => {
      const legajoId = res.data?.datos ?? null;
      this.setState({ legajoId });
    }).catch(() => {});
  }

  fetchDatosUsuario = (username) => {
    obtenerDatosUsuario(username).then((resp) => {
      if (!resp.error)
        this.setState({
          nombre: resp.datos.nombres + " " + resp.datos.apellidos,
        });
    });
  };

  fetchSaldo = (username) => {
    getSaldoByUsername(username).then((res) => {
      const saldo = res.data?.datos ?? 0;
      this.setState({ totalCorrespondientes: saldo });
    }).catch(() => {
      // Si no tiene legajo o falla, se deja vacío para que el usuario lo complete
    });
  };

  descargarRecibo = () => {
    this.setState({ openPantallaCarga: true });
    const url =
      URL + "tramite/pdf/tipoTramite/" + this.props.idFormulario;
    const bodyRequest = {
      nombreApellido: this.state.nombre,
      periodoCorrespondiente: this.state.periodo,
      fechaDesde: this.state.fechaDesde,
      fechaHasta: this.state.fechaHasta,
      diasHabilesCorrespondientes: this.state.totalCorrespondientes,
      diasHabilesPendientes: this.state.totalPendientes,
      diasHabilesSolicitados: this.state.totalSolicitados,
    };

axios
  .post(url, bodyRequest, {
    ...getAuthorizationHeader(),
    responseType: "arraybuffer", // Importante para manejar binario
  })
  .then((response) => {
    // Convertir arraybuffer a base64
    const base64String = btoa(
      new Uint8Array(response.data)
        .reduce((data, byte) => data + String.fromCharCode(byte), "")
    );

    const pdfBase64 = `data:application/pdf;base64,${base64String}`;

    this.setState({ openPantallaCarga: false });

    // Pasar el Base64 directamente a la función
    this.props.terminarCargaDatos(pdfBase64, bodyRequest);
  })
  .catch((error) => {
    this.setState({ openPantallaCarga: false });
    console.error("Error al descargar el PDF", error);
  });
  }
  validarFormulario = () => {
    let isValid = true;
    let errors = {
      periodo: null,
      fechaDesde: null,
      fechaHasta: null,
      totalCorrespondientes: null,
      totalPendientes: null,
      totalSolicitados: null,
    };
    let erroresFechas = this.validarFechas(
      this.state.fechaDesde,
      this.state.fechaHasta
    );
    errors.fechaDesde = erroresFechas.fechaDesde;
    errors.fechaHasta = erroresFechas.fechaHasta;
    if (erroresFechas.fechaDesde !== null || erroresFechas.fechaHasta !== null)
      isValid = false;

    if (this.state.periodo <= 0 || this.state.periodo === "") {
      errors.periodo = "Valor no válido";
      isValid = false;
    }

    if (
      this.state.totalCorrespondientes <= 0 ||
      this.state.totalCorrespondientes === ""
    ) {
      errors.totalCorrespondientes = "Valor no válido";
      isValid = false;
    }

    if (this.state.totalPendientes < 0 || this.state.totalPendientes === "") {
      errors.totalPendientes = "Valor no válido";
      isValid = false;
    }

    if (
      this.state.totalSolicitados <= 0 ||
      this.state.totalSolicitados === "" ||
      Number(this.state.totalSolicitados) > Number(this.state.totalCorrespondientes)
    ) {
      errors.totalSolicitados = "Valor no válido";
      isValid = false;
    }

    return { isValid, errors };
  };


  validarFechas = (desde, hasta) => {
    const fechaActual = new Date();
    let fechaDesde = new Date(desde);
    let fechaHasta = new Date(hasta);
    let erroresFechas = {
      fechaDesde: null,
      fechaHasta: null,
    };

    if (isNaN(fechaDesde.getTime())) {
      erroresFechas.fechaDesde = "Fecha inicio no válida";
    }
    if (isNaN(fechaHasta.getTime())) {
      erroresFechas.fechaHasta = "Fecha fin no válida";
    }
    if (!fechaDesde.getDate() >= fechaActual.getDate()) {
      erroresFechas.fechaDesde = "Fecha inicio es menor a fecha actual";
    }
    if (fechaHasta.getTime() < fechaDesde.getTime()) {
      erroresFechas.fechaHasta = "Fecha fin es menor o igual a fecha inicio";
    }

    return erroresFechas;
  };

  calcularDiasHabiles = (desde, hasta) => {
    if (!desde || !hasta) return;
    const formatFecha = (d) => {
      const anio = d.getFullYear();
      const mes = String(d.getMonth() + 1).padStart(2, '0');
      const dia = String(d.getDate()).padStart(2, '0');
      return `${anio}-${mes}-${dia}`;
    };
    const params = {
      empresaId: idEmpresa(),
      desde: formatFecha(desde),
      hasta: formatFecha(hasta)
    };
    if (this.state.legajoId) params.legajoId = this.state.legajoId;
    axios.get(`${URL}feriados/diasHabiles`, {
      params,
      ...getAuthorizationHeader()
    }).then(res => {
      const diasHabiles = res.data;
      const correspondientes = parseInt(this.state.totalCorrespondientes) || 0;
      this.setState({
        totalSolicitados: diasHabiles,
        totalPendientes: Math.max(0, correspondientes - diasHabiles)
      });
    }).catch(() => {
      // Si falla el cálculo, el usuario puede ingresar el valor manualmente
    });
  }

  handleFechaDesdeChange = (date) => {
    this.setState((prevState) => ({
      errors: {
        ...prevState.errors,
        fechaDesde: null,
      },
      fechaDesde: date,
      fechaDesdeCargada: true
    }), () => {
      this.calcularDiasHabiles(date, this.state.fechaHasta);
    });
    limpiarErrorCampo("fechaDesde")
  }

  handleFechaHastaChange = (date) => {
    this.setState((prevState) => ({
      errors: {
        ...prevState.errors,
        fechaHasta: null,
      },
      fechaHasta: date,
      fechahastaCargada: true
    }), () => {
      this.calcularDiasHabiles(this.state.fechaDesde, date);
    });
    limpiarErrorCampo("fechaHasta")
  }

  handleSubmit = (event) => {
    event.preventDefault();
    const { isValid, errors } = this.validarFormulario();
    if (!isValid) {
      this.setState({ errors: errors, showErrors: true });
      mostrarErroresEnFormulario(errors);
    } else {
      mostrarErroresEnFormulario({});
      this.descargarRecibo();
    }
  };

  handleBotonCancelar = () => {
    this.props.history.push('/tramites/generar')
  }

  handleInput = (e) => {
    const name = e.target.name;
    const val = e.target.value;
    this.setState((prevState) => {
      const newState = {
        errors: { ...prevState.errors, [name]: null },
        [name]: val,
      };
      // Recalcular días pendientes automáticamente
      if (name === "totalSolicitados") {
        const solicitados = parseInt(val) || 0;
        const correspondientes = parseInt(prevState.totalCorrespondientes) || 0;
        newState.totalPendientes = Math.max(0, correspondientes - solicitados);
      }
      return newState;
    });
  };

  render() {
    return (
      <>
        <PantallaCarga open={this.state.openPantallaCarga} />
        <form onSubmit={this.handleSubmit}>

          <div className="form-group">
            <input type="number" id="periodo" name="periodo" className="form-input" min={1} placeholder="" value={this.state.periodo} onChange={this.handleInput} />
            <label htmlFor="periodo" className="form-label"> Periodo Correspondiente </label>
          </div>

          <div className="form-group__inline x2">

            <div className="form-group">
              <DatePicker
                showIcon
                selectsStart
                name="fechaDesde"
                selected={this.state.fechaDesde}
                onChange={this.handleFechaDesdeChange}
                customInput={
                  <CustomDateInput name="fechaDesde" label="Fecha desde" />
                }
                startDate={this.state.fechaDesde}
                dateFormat="dd/MM/yyyy"
                minDate={new Date()}
                required
              />
            </div>

            <div className="form-group">
              <DatePicker
                showIcon
                selectsEnd
                selected={this.state.fechaHasta}
                name="fechaHasta"
                customInput={
                  <CustomDateInput name="fechaHasta" label="Fecha hasta" />
                }
                onChange={this.handleFechaHastaChange}
                dateFormat="dd/MM/yyyy"
                endDate={this.state.fechaHasta}
                startDate={this.state.fechaDesde}
                minDate={this.state.fechaDesde}
                required
              />

            </div>
          </div>
          <div className="form-group__inline x3">
            <div className="form-group">
              <input type="number" id="totalCorrespondientes" name="totalCorrespondientes" className="form-input" placeholder="" value={this.state.totalCorrespondientes} readOnly />
              <label htmlFor="totalCorrespondientes" className="form-label"> Dias habiles disponibles </label>
            </div>

            <div className="form-group">
              <input type="number" id="totalSolicitados" name="totalSolicitados" className="form-input" placeholder="" value={this.state.totalSolicitados} onChange={this.handleInput} min={1} />
              <label htmlFor="totalSolicitados" className="form-label"> Dias habiles solicitados </label>
            </div>

            <div className="form-group">
              <input type="number" id="totalPendientes" name="totalPendientes" className="form-input" placeholder="" value={this.state.totalPendientes} readOnly />
              <label htmlFor="totalPendientes" className="form-label"> Dias habiles pendientes </label>
            </div>
          </div>

          <div className="form-actions">
            <button onClick={()=> this.handleBotonCancelar()} className="btn-medium btn-link"> Cancelar </button>
            <button type="submit" className="btn-medium btn-primary"> Continuar </button>
          </div>

        </form>
      </>
    );
  }
}
export default withRouter(SolicitudVacaciones)